module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/home-garden-mobile-0432b3cc685ff7c76da0a05dc35787f1.png";